import React from 'react';
import { Button, Card, CardActions, CardContent, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: 8,
      backgroundColor: 'white',
      padding: '48px 36px',
      width: 905,
      border: 'none',
      boxShadow: 'rgba(35, 63, 77, 0.1) 0px 8px 24px 8px',
    },
    title: {
      fontWeight: 900,
      fontSize: 24,
    },
    body: {
      fontWeight: 400,
      width: '90%',
      fontSize: 16,
      color: theme.color.grey.neutral400,
      marginTop: 14,
    },
    actions: {
      marginTop: 36,
      justifyContent: 'end',
    },
    button: {
      textTransform: 'none',
      width: 82,
      height: 38,
      borderRadius: 6,
    },
  })
);

export function TrialExpiredScreen() {
  const classes = useStyles();
  const history = useHistory();
  const onNext = () => {
    history.push('/subscriptions/options');
  };

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography variant='h3' className={classes.title}>
          Your Free Trial has Ended
        </Typography>
        <Typography className={classes.body}>
          Your organisation&apos;s free trial with Volaby has ended. If you&apos;d like to continue to use Volaby, click
          next and get started with a Volaby plan today.
        </Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button variant='contained' color='primary' className={classes.button} onClick={onNext}>
          Next
        </Button>
      </CardActions>
    </Card>
  );
}
